import type { JSX, PropsWithChildren } from 'react';

import { Link } from '@change/ds-core-ui/next';

import type { QrCodeType } from '@change-corgi/middle-end-gql-schema';

import { usePetitionQRCode } from 'src/app/shared/hooks/qrcode';

type PetitionQRCodeDownloadLinkProps = PropsWithChildren<{
	slugOrId: string;
	type: QrCodeType;
	size: number;
	filename?: string;
	onDownload?: () => Promise<void>;
}>;
/**
 * Renders a link to download a QR code with the given value.
 * The QRCode is not visible, but is used to download a hi-res version of the QRCode
 */
export function PetitionQRCodeDownloadLink({
	children,
	slugOrId,
	size,
	type,
	filename,
	onDownload,
}: PetitionQRCodeDownloadLinkProps): JSX.Element {
	const { data } = usePetitionQRCode({ slugOrId, size, type, adjustForPixelRatio: false });

	const handleDownload = async () => {
		await onDownload?.();
	};

	return (
		<Link
			href={data?.imageBase64Uri ?? '#'}
			download={filename || true}
			onClick={handleDownload}
			bold
			size="small"
			variant="secondary"
			data-qa="qrcode-download-link"
			data-testid="qrcode-download-link"
		>
			{children}
		</Link>
	);
}
